import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  Inject,
  ViewChild,
  inject,
} from '@angular/core';
import { Floor } from '../../../models';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import { WorkplaceService } from '../../../services/workplace.service';
import { Workplace } from '../../../models/workplace.model';
import { Coordinates } from '../../../models/coordinates.model';
import { ToastAlertService, SpinnerService } from '@core/services';
import { ConfirmacionDialogComponent } from '../index';
import { NewJobComponent } from '../new-job/new-job.component';
import { InfoJobComponent } from '../info-job';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FloorService } from '../../../services';
import { NgIf } from '@angular/common';
import { TitleComponent } from '@shared/components/title/title.component';
import { ButtonComponent } from '@shared/components/button/button.component';
import { PinchZoomModule } from '@meddv/ngx-pinch-zoom';

@Component({
  selector: 'app-generate-map',
  templateUrl: './generate-map.component.html',
  styles: [
    `
      .spinner {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }

      .circle {
        width: 20px;
        height: 20px;
        background-color: black;
        border-radius: 50%;
        margin: 5px;
      }
    `,
  ],
  standalone: true,
  imports: [
    ButtonComponent,
    MatDialogClose,
    TitleComponent,
    NgIf,
    PinchZoomModule,
  ],
})
export class GenerateMapComponent implements AfterViewInit {
  private destroyRef = inject(DestroyRef);
  private dialog = inject(MatDialog);
  private alertService = inject(ToastAlertService);
  private workplaceService = inject(WorkplaceService);
  private diagolRef = inject(MatDialogRef);
  private _spinner = inject(SpinnerService);
  private floorService = inject(FloorService);
  x: number;
  y: number;
  namefloor: string;
  isLoading = false;
  dataMap = '';
  @ViewChild('canvas') canvas!: ElementRef; // ViewChild para obtener una referencia al elemento canvas en el componente
  //*create array
  workplace: Workplace[] = [];
  datafoor: Floor[] = [];
  co: Coordinates[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<GenerateMapComponent>
  ) {
    this.dialogRef.disableClose = true; //permite no cerrar el modal
    this.dataMap = '';
    this.x = 0;
    this.y = 0;
    this.namefloor = data.name;
  }
  ngAfterViewInit(): void {
    this.loadMap();
    this.llenarDatosCirculos();
  }

  loadMap() {
    this.isLoading = true;
    this.floorService.getFloorMap(this.data.floorid).subscribe({
      next: request => {
        if (request.code === 10000) {
          this.dataMap = request.reply[0].map || [];
        }
      },
      complete: () => {
        this.isLoading = false;
        this.createImg(); // Llama a la función createImg después de que la imagen se haya cargado
      },
    });
  }

  image = new Image(); // Crea una nueva instancia de la clase Image
  createImg() {
    this.image.src = this.dataMap; // Establece la fuente de la imagen en la URL proporcionada
    const ctx: CanvasRenderingContext2D =
      this.canvas.nativeElement.getContext('2d'); // Obtiene el contexto 2D del elemento canvas
    // Cuando la imagen se carga correctamente, se ejecuta  función de devolución de llamada
    this.image.onload = () => {
      const imageWidth = this.image.width;
      const imageHeight = this.image.height;
      // Borra el contenido del canvas actual
      this.clearCanvas();
      ctx.drawImage(
        this.image,
        0,
        0,
        (this.canvas.nativeElement.width = this.image.width), //asignar tamano del canvas con el de la imagen
        (this.canvas.nativeElement.height = this.image.height)
      );
      //*Funcion que dibuja un circulos
      this.drawCircles(imageWidth, imageHeight);
    };
  }
  //* Función para dibujar los círculos
  drawCircles(imageWidth: number, imageHeight: number) {
    const ctx: CanvasRenderingContext2D =
      this.canvas.nativeElement.getContext('2d');
    //* Llamar a la función para obtener y dibujar las coordenadas
    this.getCoordinates(this.data.floorid, ctx, imageWidth, imageHeight);
  }
  clearCanvas() {
    const ctx: CanvasRenderingContext2D =
      this.canvas.nativeElement.getContext('2d');
    ctx.clearRect(
      0,
      0,
      this.canvas.nativeElement.width,
      this.canvas.nativeElement.height
    );
  }
  calculateScaledRadius(
    point: Workplace,
    canvasWidth: number,
    canvasHeight: number,
    newImageWidth: number,
    newImageHeight: number
  ): number {
    // Calcula un radio escalable en función de las dimensiones de la imagen
    const scaleFactor = 0.020; // Factor de escala (ajusta de radio) - Aumentado para puntos más grandes
    const radiusX = newImageWidth * scaleFactor * (canvasWidth / newImageWidth);
    const radiusY =
      newImageHeight * scaleFactor * (canvasHeight / newImageHeight);
    return radiusX;
  }
  drawCircle(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    radius: number,
    color: string,
    opacity: number
  ) {
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, 2 * Math.PI);
    ctx.fillStyle = color;
    ctx.globalAlpha = opacity;
    ctx.fill();
    ctx.closePath();
    ctx.globalAlpha = 1; // Restablece la opacidad a su valor predeterminado
  }
  // //*Funcion para obtener las cordenadas x,y y dibuja el circulo
  getCoordinates(
    id: number,
    ctx: CanvasRenderingContext2D,
    newImageWidth: number,
    newImageHeight: number
  ) {
    this.workplaceService
      .getkorkplace(id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            const workplaceData: Workplace[] = resp.reply || [];
            // Obtener las dimensiones del nuevo nivel (nueva imagen)
            const canvasWidth = this.canvas.nativeElement.width;
            const canvasHeight = this.canvas.nativeElement.height;
            workplaceData.forEach(point => {
              const { x, y } = point;
              // Ajustar las coordenadas en función del tamaño original de la imagen
              const adjustedX = (x / newImageWidth) * canvasWidth;
              const adjustedY = (y / newImageHeight) * canvasHeight;
              // Calcular el radio escalable
              const radius = this.calculateScaledRadius(
                point,
                canvasWidth,
                canvasHeight,
                newImageWidth,
                newImageHeight
              );
              // Llama a la función drawCircle con las coordenadas y los radios ajustados
              this.drawCircle(ctx, adjustedX, adjustedY, radius, 'red', 0.5);
              //Array que me guarda las cordenadas
              const coordenadas: Coordinates = {
                adjustedX: adjustedX,
                adjustedY: adjustedY,
              };
              this.co.push(coordenadas);
            });
          }
        },
      });
  }

  dataInfo!: Workplace;
  /* determinar si un punto de coordenadas (x, y) en el lienzo (canvas) se encuentra dentro de alguno
  de los círculos representados en el área de trabajo (workspace) del componente*/
  isInsideAnyCircle(
    x: number,
    y: number,
    canvasWidth: number,
    canvasHeight: number
  ): boolean {
    // Itera sobre el array this.workplace y verifica si el clic está dentro de algún círculo
    for (const punto of this.workplace) {
      const radio = this.calculateScaledRadius(
        punto,
        canvasWidth,
        canvasHeight,
        this.image.width,
        this.image.height
      );
      const distancia = Math.sqrt((x - punto.x) ** 2 + (y - punto.y) ** 2);
      if (distancia < radio) {
        this.dataInfo = punto;
        return true;
      }
    }
    return false;
  }

  llenarDatosCirculos() {
    // Obtiene y llena el array this.workplace con información de los círculos desde tu servicio
    this.workplaceService
      .getkorkplace(this.data.floorid)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: resp => {
          if (resp.code === 10000) {
            this.workplace = resp.reply || [];
          }
        },
      });
  }

  canvasDblClickk(event: MouseEvent) {
    // Obtener las dimensiones del nuevo nivel (nueva imagen)
    const canvasWidth = this.canvas.nativeElement.width;
    const canvasHeight = this.canvas.nativeElement.height;
    const x = event.offsetX;
    const y = event.offsetY;

    // Ajustar las coordenadas en función del tamaño original de la imagen
    const adjustedX = (x / this.image.width) * canvasWidth;
    const adjustedY = (y / this.image.height) * canvasHeight;

    // Verifica si las coordenadas (x, y) están dentro de los límites de la imagen
    if (x >= 0 && x <= this.image.width && y >= 0 && y <= this.image.height) {
      const isInsideCircle = this.isInsideAnyCircle(
        x,
        y,
        canvasWidth,
        canvasHeight
      );
      // Verifica si las coordenadas (x, y) no están en el array de coordenadas co
      const isOutsideSavedCoordinates = !this.isInsideSavedCoordinates(x, y);

      if (!isInsideCircle && isOutsideSavedCoordinates) {
        // Abre el cuadro de diálogo de confirmación personalizado
        const dialogRef = this.dialog.open(ConfirmacionDialogComponent, {
          data: this.data,
        });

        // Escucha el resultado del cuadro de diálogo
        dialogRef
          .afterClosed()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(result => {
            if (result === true) {
              // El usuario confirmó, abre el modal
              this.openModal(adjustedX, adjustedY);
            }
          });
      } else {
        // Calcula el índice del círculo en el que se hizo clic
        const circleIndex = this.getCircleIndex(adjustedX, adjustedY);

        if (circleIndex !== -1) {
          // Si se hace clic en un círculo, abre el modal de información del círculo
          this.openInfoJobModal();
        } else {
          // Si no se hace clic en un círculo, abre el modal general
          this.openModal(adjustedX, adjustedY);
        }
      }
    }
  }

  private touchTimeout: any;
  private lastTouchTime: number = 0;

  onTouchStart(event: TouchEvent) {
    const currentTime = new Date().getTime();
    const timeDiff = currentTime - this.lastTouchTime;

    if (timeDiff < 300 && timeDiff > 0) {
      this.canvasDblClick(event);
      event.preventDefault();
    }

    this.lastTouchTime = currentTime;
  }

  onTouchEnd(event: TouchEvent) {
    clearTimeout(this.touchTimeout);
    this.touchTimeout = setTimeout(() => {
      this.lastTouchTime = 0;
    }, 300);
  }
  canvasDblClick(event: TouchEvent) {
    const touch = event.changedTouches[0];
    const x = touch.clientX;
    const y = touch.clientY;

    const canvasElement = this.canvas.nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const adjustedX = ((x - rect.left) / rect.width) * canvasElement.width;
    const adjustedY = ((y - rect.top) / rect.height) * canvasElement.height;

    // Verifica si las coordenadas (x, y) están dentro de los límites de la imagen
    if (
      adjustedX >= 0 &&
      adjustedX <= this.image.width &&
      adjustedY >= 0 &&
      adjustedY <= this.image.height
    ) {
      const isInsideCircle = this.isInsideAnyCircle(
        adjustedX,
        adjustedY,
        canvasElement.width,
        canvasElement.height
      );
      const isOutsideSavedCoordinates = !this.isInsideSavedCoordinates(
        adjustedX,
        adjustedY
      );

      if (!isInsideCircle && isOutsideSavedCoordinates) {
        const dialogRef = this.dialog.open(ConfirmacionDialogComponent, {
          data: this.data,
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result === true) {
            this.openModal(adjustedX, adjustedY);
          }
        });
      } else {
        const circleIndex = this.getCircleIndex(adjustedX, adjustedY);

        if (circleIndex !== -1) {
          this.openInfoJobModal();
        } else {
          this.openModal(adjustedX, adjustedY);
        }
      }
    }
  }

  //Funcion que me verifica si existe un puesto de trabajo en las coordenadas x, y
  getCircleIndex(x: number, y: number): number {
    for (let i = 0; i < this.co.length; i++) {
      const coordinate = this.co[i];
      const radius = this.calculateScaledRadius(
        this.workplace[i],
        this.canvas.nativeElement.width,
        this.canvas.nativeElement.height,
        this.image.width,
        this.image.height
      );
      const distance = Math.sqrt(
        (coordinate.adjustedX - x) ** 2 + (coordinate.adjustedY - y) ** 2
      );

      // Verifica si el clic está dentro del círculo
      if (distance <= radius) {
        return i; // Devuelve el índice cuando se encuentra la coincidencia
      }
    }

    return -1; // Retorna -1 si no se encuentra ninguna coincidencia
  }

  isInsideImageBounds(x: number, y: number): boolean {
    // Comprueba si las coordenadas (x, y) están dentro de los límites de la imagen
    const canvasWidth = this.canvas.nativeElement.width;
    const canvasHeight = this.canvas.nativeElement.height;
    return x >= 0 && x <= canvasWidth && y >= 0 && y <= canvasHeight;
  }

  isInsideSavedCoordinates(x: number, y: number): boolean {
    // Comprueba si las coordenadas (x, y) coinciden con alguna coordenada almacenada en el array co
    return this.co.some(
      coordinate => coordinate.adjustedX === x && coordinate.adjustedY === y
    );
  }

  openModal(x: number, y: number) {
    // Abre el modal y pasa las coordenadas (x, y) al modal
    const dialogRef = this.dialog.open(NewJobComponent, {
      width: '40rem',
      height: '38rem',
      data: {
        x: x,
        y: y,
        idfoor: this.data.floorid,
        isparking: this.data.isparking,
        businessId: this.data.businessId,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        // Maneja cualquier acción después de que se cierre el modal si es necesario.
        if (result == 'recargar') {
          this.workplace = [];
          this.datafoor = [];
          this.co = [];
          this.createImg();
          this.llenarDatosCirculos();
        }
      });
  }

  openInfoJobModal() {
    const dialogRef = this.dialog.open(InfoJobComponent, {
      width: '45rem',
      height: '40rem',
      data: {
        action: this.dataInfo,
        idfoor: this.data.floorid,
        logo_id: this.data.logo_id,
        isparking: this.data.isparking,
        businessId: this.data.businessId,
      }, //Objeto del workplace
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result == 'recargar') {
          this.workplace = [];
          this.datafoor = [];
          this.co = [];
          this.createImg();
          this.llenarDatosCirculos();
        } else if (result == 'cerrar') {
          this.diagolRef.close('cerrar');
        }
      });
  }
}
